// Angular
import { Component, Input, OnInit, OnDestroy, SimpleChanges, OnChanges, Renderer2 } from '@angular/core';

// Store
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store/index';

// Services
import { UtilsService } from '../../../services/api/utils.service';
import { SoledadUserService } from '../../../services/b2b/user.service';

import { TranslateService } from '@ngx-translate/core';

import { ToastUtilsService } from '../../../../shared/services/api/toast-utils.service';

// Helpers
import { isEmptyObject, isUndefined } from '../../../../shared/lib/helpers/utils';
import { Subscriber } from '../../../../shared/lib/helpers/subscriber';

// Moment
import * as moment from 'moment';

// Models
import { Delivery } from '../../../../shared/models/b2b/delivery';
import { DeliveryStatus } from '../../../models/b2b/deliveryStatus';
import { User } from '../../../models/b2b/user';
import { ModalsService } from '../../../../shared/services/utils/modals.service';
import { EventsService } from '../../../../../app/shared/services/utils/events.service';
import { ToastDataHelper } from '../../../../../app/shared/models/b2b/toastData';

@Component({
    selector: 'app-item-order-list',
    templateUrl: './item-order-list.component.html'
})
export class ItemOrderListComponent extends Subscriber implements OnInit, OnDestroy, OnChanges {
    @Input() item: Delivery;
    @Input() statusOptions: DeliveryStatus[];

    estado: string;
    loading: boolean;
    loadingA: boolean;
    user: User;

    constructor(
        private store: Store<AppState>,
        private utilsService: UtilsService,
        public usersService: SoledadUserService,
        private translatesService: TranslateService,
        private modalsService: ModalsService,
        private eventsService: EventsService
    ) {
        super();
    }

    ngOnInit(): void {
        this.subscribeUserData();
    }

    ngOnChanges(changes: SimpleChanges): void {
        // console.log(changes.statusOptions);
        this.changeProductStatus();
    }

    subscribeUserData(): void {
        this.addSubscription(
            this.store
                .select((state) => state.user.data)
                .subscribe((user) => {
                    // console.log({user});
                    if (user) {
                        this.user = user;
                    }
                })
        );
    }

    changeProductStatus() {
        // console.log('changeProductStatus', this.item, this.statusOptions);
        if (this.statusOptions) {
            switch (this.item.estado) {
                case 1:
                    // this.estado = 'SERVIDO';
                    this.estado = this.statusOptions['1'].label;
                    break;

                case 2:
                    // this.estado = 'S/PARCIAL';
                    this.estado = this.statusOptions['2'].label;
                    break;

                case 3:
                    // this.estado = 'PENDIENTE';
                    this.estado = this.statusOptions['3'].label;
                    break;

                default:
                    this.estado = '-';
            }
        }
    }

    subscribePDF(): void {
        this.loading = true;
        this.addSubscription(
            this.usersService.deliveryPrint(this.item.serie, this.item.numero, this.item.fecha).subscribe(
                (data) => {
                    // console.log({data});
                    if (!isUndefined(data)) {
                        this.item.URL_PDF = data;
                        // console.log('PDF: ', this.item.URL_PDF);
                        this.loading = false;
                        //this.utilsService.downloadPDF(this.item.URL_PDF);
                        this.downloadPDF(this.item);
                    }
                },
                (error) => {
                    console.log('error');
                }
            )
        );
    }

    downloadPDF(item) {
        if (!this.utilsService.downloadPDF(item.URL_PDF)) {
            this.translatesService
                .get('error_popup_blocker_detected')
                .subscribe((texto) => this.showToast(texto, false));
        }
    }

    showToast(msg: string, success: boolean) {
        this.eventsService.broadcast(
            'showToast',
            ToastDataHelper.create({ type: success ? 'success' : 'error', text: msg })
        );
    }

    clickPrint(ev): void {
        ev.stopPropagation();
        ev.preventDefault();

        this.utilsService.printPdf(this.item.URL_PDF);
    }

    susbscribeDeliveryNotePDF(order: any) {
        this.loadingA = true;
        const date = moment().year(order.albaranAnio).toDate();
        // console.log(date);

        this.addSubscription(
            this.usersService.notePrint(' ', order.albaran, date).subscribe(
                (data) => {
                    if (!isUndefined(data)) {
                        this.item.URL_PDF = data;
                        //this.utilsService.downloadPDF(this.item.URL_PDF);
                        this.downloadPDF(this.item);
                        this.loadingA = false;
                    }
                },
                (error) => {
                    console.log('error');
                }
            )
        );
    }

    clickDownloadDeliveryNote(ev, item): void {
        ev.stopPropagation();
        ev.preventDefault();

        this.susbscribeDeliveryNotePDF(item);
    }
    clickDownloadOrder(ev): void {
        // console.log("descargar factura: ", this.item.URL_PDF);
        ev.stopPropagation();
        ev.preventDefault();

        this.subscribePDF();
        // this.utilsService.downloadPDF(this.item.URL_PDF);
    }

    clickNewIncidence(event: Event): void {
        event.preventDefault();
        this.modalsService.open('incidents-new', null, {
            typeIncident: 'Pedido',
            user: this.user,
            itemId: this.item.numero.toString()
        });
    }

    isComercial(tipo: string): boolean {
        return tipo === 'COMERCIAL';
    }
}
